export default __webpack_public_path__ + "static/media/in-person-facilitation.913d5df9.pdf";